import { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import { cn } from "@/lib/utils";

const DISMISS_KEY = "maintenance_banner_dismissed";

export function MaintenanceBanner() {
  const { isMaintenanceMode, message, isLoading } = useMaintenanceMode();
  const [isDismissed, setIsDismissed] = useState(false);

  // Check if banner was dismissed this session
  useEffect(() => {
    const dismissed = sessionStorage.getItem(DISMISS_KEY);
    if (dismissed === "true") {
      setIsDismissed(true);
    }
  }, []);

  // Reset dismissed state when maintenance mode is toggled off and on
  useEffect(() => {
    if (!isMaintenanceMode) {
      sessionStorage.removeItem(DISMISS_KEY);
      setIsDismissed(false);
    }
  }, [isMaintenanceMode]);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, "true");
  };

  // Don't show if loading, not in maintenance mode, or dismissed
  if (isLoading || !isMaintenanceMode || isDismissed) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-amber-950",
        "px-4 py-2.5 flex items-center justify-center gap-3",
        "shadow-md"
      )}
    >
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span className="text-sm font-medium text-center flex-1">
        {message}
      </span>
      <button
        onClick={handleDismiss}
        className="shrink-0 p-1 rounded-md hover:bg-amber-600/20 transition-colors"
        aria-label="Fechar aviso"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
